var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 473.12 104.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4e4d4d;}.cls-2{fill:none;}.cls-3{fill:#5e86b7;}.cls-4{fill:#253d74;}.cls-5{fill:#25407d;}.cls-6{fill:#2d4d8f;}.cls-7{fill:#2d4c95;}.cls-8{fill:#35579f;}.cls-9{fill:#3d64a6;}.cls-10{fill:#4b74ae;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_original"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.89,39.74c-12.27,0-21,7.92-23.25,21.17H343C341,47.09,332.88,39.74,320.89,39.74Zm-21.68,20C301.35,48.09,309.62,41,320.89,41s18.69,6.77,20.55,18.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M459.14,1.73V38.16C452.87,31.1,444.3,27.5,433.75,27.5c-22.69,0-36.24,19.59-36.24,38.45s13.55,38.45,36.24,38.45c10.55,0,19.12-3.6,25.39-10.8v8.93h14V1.73ZM472,101.37h-11.7V90l-1.14,1.44c-6,7.77-14.55,11.66-25.39,11.66-21.83,0-35-18.86-35-37.15s13.13-37.15,35-37.15c10.84,0,19.4,3.89,25.39,11.52l1.14,1.44V3H472Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M435,39.74c-14.55,0-24.25,10.51-24.25,26.21,0,15.55,9.7,26.21,24.25,26.21,15.12,0,25.25-10.66,25.25-26.21C460.28,50.25,450.15,39.74,435,39.74Zm0,51.12c-13.84,0-23.11-10.08-23.11-24.91S421.19,41,435,41C449.44,41,459.14,51,459.14,66S449.44,90.86,435,90.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.54,1.58a8.11,8.11,0,0,0-8,8.07,8,8,0,1,0,16,0A8.11,8.11,0,0,0,263.54,1.58Zm0,14.84a6.77,6.77,0,1,1,6.71-6.77A6.73,6.73,0,0,1,263.54,16.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.55,102.53h14V29.23h-14Zm1.14-72h11.7v70.84h-11.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213,29.23H201.77V42.77H213v59.76h14.12V42.77h16.55V29.23H227.16c.14-11.37,2.14-17.13,12.41-17.13,1,0,2.57.14,4.14.28V.29C242,.14,240.14,0,238.15,0,221.74,0,213.18,9.79,213,29.23Zm29.39-18.29c-.43,0-2-.14-2.86-.14C227,10.8,226,19.87,225.88,30v.58h16.55V41.47H225.88v59.9H214.32V41.47H202.91V30.53h11.41V30c0-19.29,7.85-28.65,23.83-28.65a40.94,40.94,0,0,1,4.28.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.83,102.53H384V1.73H369.83ZM371.12,3h11.55v98.35H371.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.89,27.5c-20.54,0-36.66,16.85-36.66,38.45,0,22.18,16.4,38.45,38.95,38.45,13,0,23.25-5,30.1-14.55l-11.56-7.34c-4.28,5.33-11.12,8.35-18.54,8.35-12.7,0-21.69-7-24-18.72h56.64c1.57-13.1-1.43-24.48-8.7-32.68A34.51,34.51,0,0,0,320.89,27.5Zm33.82,43.35H297.64c2.42,13.53,11.56,21.31,25.54,21.31,7.56,0,14.55-3,18.83-8.07l9.41,6.2c-6.13,8.2-16.12,12.81-28.24,12.81-22.26,0-37.81-15.26-37.81-37.15,0-21.17,15.26-37.15,35.52-37.15a34.1,34.1,0,0,1,25.4,11.38C353.14,48.09,356.13,58.89,354.71,70.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.55,45.29H76.34a26.25,26.25,0,0,0-1.27-4.13,27,27,0,0,0-5.31-8.42,25.61,25.61,0,0,0-8.05-5.8,24.71,24.71,0,0,0-20.34,0,25.73,25.73,0,0,0-8,5.8,27.56,27.56,0,0,0,0,37.19,25.73,25.73,0,0,0,8,5.8,24.71,24.71,0,0,0,20.34,0,25.61,25.61,0,0,0,8.05-5.8,26.77,26.77,0,0,0,5.31-8.49,27.45,27.45,0,0,0,1.63-6.06H47.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "51.39 47.64 51.39 53.04 79.07 53.04 103.96 53.04 123.56 53.04 123.56 47.64 103.78 47.64 78.73 47.64 51.39 47.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "51.39 50.48 51.39 53.04 79.07 53.04 103.96 53.04 123.56 53.04 123.56 50.48 103.78 50.48 78.73 50.48 51.39 50.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "100.31 102.5 132.66 102.5 118.57 74.93 100.31 102.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "169.36 102.5 201.84 102.5 183.5 74.93 169.36 102.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "118.57 74.93 151 74.96 132.64 102.5 118.57 74.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "151 74.96 183.5 74.93 169.36 102.5 151 74.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "118.57 74.93 151 74.96 134.77 50.48 118.57 74.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "151 74.96 183.5 74.93 167.25 50.48 151 74.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "167.25 50.48 134.77 50.48 151 74.96 167.25 50.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "134.76 50.48 167.25 50.48 151 26.13 134.76 50.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "134.76 50.48 151 26.13 118.57 26.13 134.76 50.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "167.25 50.48 183.44 26.13 151 26.13 167.25 50.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "118.57 26.13 151 26.13 133.71 0.04 118.57 26.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "151 26.13 168.3 0.04 183.44 26.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "118.57 26.13 133.71 0.04 101.23 0.04 118.57 26.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "183.44 26.13 200.79 0.04 168.31 0.04 183.44 26.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "117.77 68.01 129.36 50.48 117.77 50.48 117.77 68.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "117.77 32.95 129.36 50.48 117.77 50.48 117.77 32.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.24,87.33A51.66,51.66,0,0,0,99,71.3a48.72,48.72,0,0,0,3.52-12.58H76c-.26.92-.56,1.83-.91,2.72a27.12,27.12,0,0,1-4.81,7.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M70.26,69.35c-.17.19-.32.39-.5.58a25.61,25.61,0,0,1-8.05,5.8,23.69,23.69,0,0,1-10.17,2.19h-.15V102.5h.15a50.83,50.83,0,0,0,20-4A51.68,51.68,0,0,0,88,87.59l.26-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M14.7,87.17l18-18a27.51,27.51,0,0,1-6.61-17.85q0-.49,0-1H0c0,.33,0,.66,0,1a49.56,49.56,0,0,0,4.06,20A51.39,51.39,0,0,0,14.7,87.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M33.32,69.93c-.24-.26-.46-.55-.69-.82l-18,18,.47.49A51.86,51.86,0,0,0,31.45,98.51a50.71,50.71,0,0,0,19.94,4V77.91a23.67,23.67,0,0,1-10-2.18A25.73,25.73,0,0,1,33.32,69.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M15.56,14.65l-.46.43a51.46,51.46,0,0,0-11,16.29A49.48,49.48,0,0,0,0,50.48H26.1a27.28,27.28,0,0,1,7.22-17.74c0-.06.12-.11.17-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.49,32.58a25.65,25.65,0,0,1,7.88-5.64,23.67,23.67,0,0,1,10-2.18V.05A49.71,49.71,0,0,0,31.45,4.1,52.93,52.93,0,0,0,15.56,14.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99,31.37A51.49,51.49,0,0,0,88,15.08l-.61-.58L69.44,32.43c.11.11.22.2.32.31a27,27,0,0,1,5.31,8.42c.14.36.25.72.38,1.08h26.83A48.28,48.28,0,0,0,99,31.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M61.71,26.94a25.77,25.77,0,0,1,7.73,5.49L87.37,14.5A52.83,52.83,0,0,0,71.57,4.1,50.19,50.19,0,0,0,51.54,0h-.15V24.76h.15A23.69,23.69,0,0,1,61.71,26.94Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logoHeader.19acef9e23b9f5cb74c43f821022b6cf.svg";
export { ForwardRef as ReactComponent };